import {
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';

const PREFIX = 'AppMenuListLink';

const classes = {
  root: `${PREFIX}-root`,
  link: `${PREFIX}-link`,
  listItem: `${PREFIX}-listItem`,
  toolbar: `${PREFIX}-toolbar`,
  normal: `${PREFIX}-normal`,
  home: `${PREFIX}-home`,
  listItemIcon: `${PREFIX}-listItemIcon`,
  divider: `${PREFIX}-divider`,
  active: `${PREFIX}-active`,
  listItemLabel: `${PREFIX}-list-item-label`,
};

const Root = styled('div', {
  shouldForwardProp: prop => prop !== 'isTemporary',
})(({ theme, isTemporary }) => ({
  [`& .${classes.root}`]: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    paddingTop: '0px',
  },

  [`& .${classes.link}`]: {
    textDecoration: 'none',
    color: 'inherit',
  },

  [`& .${classes.listItem}`]: {
    padding: '8px 24px 8px 24px',
    marginBottom: '8px',
    color: theme.palette.background.paper,
    [theme.breakpoints.only('lg')]: {
      paddingLeft: '20px',
    },
  },

  [`& .${classes.toolbar}`]: theme.mixins.toolbar,

  [`& .${classes.normal}`]: {
    height: '48px',
  },

  [`& .${classes.home}`]: {
    marginBottom: '0px',
  },

  [`& .${classes.listItemIcon}`]: {
    minWidth: '40px',
    color: theme.palette.background.paper,
  },

  [`& .${classes.listItemLabel}`]: {
    [theme.breakpoints.only('lg')]: {
      display: isTemporary ? undefined : 'none',
    },
  },

  [`& .${classes.divider}`]: {
    marginBottom: '8px',
  },

  [`& .${classes.active}`]: {
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.background.paper,
    '& .MuiListItemIcon-root': {
      color: theme.palette.background.paper,
    },
  },
}));

const AppMenuListLink = ({
  label,
  to,
  activeOnlyWhenExact,
  icon,
  toolbar,
  divider,
  isTemporary,
  ...rest
}) => {
  const match = useRouteMatch({
    path: to,
    exact: activeOnlyWhenExact,
  });
  const dataTestId = rest['data-test'];
  return (
    <Root isTemporary={isTemporary}>
      <Link to={to} className={classes.link}>
        <ListItem
          button
          className={`${classes.listItem} ${classes.home} ${
            toolbar ? classes.toolbar : classes.normal
          } ${match ? classes.active : ''}`}
          data-test={dataTestId}
        >
          <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon>
          <ListItemText
            primary={
              <>
                <Typography component="span" variant="body2">
                  {label}
                </Typography>
              </>
            }
            className={classes.listItemLabel}
          />
        </ListItem>
        {divider ? <Divider /> : null}
      </Link>
    </Root>
  );
};

export default AppMenuListLink;
